import React, { useState } from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { DateRangePicker } from "../../../../../../shared/DateRangePicker/DateRangePicker";
import { useCurrentUserQuery } from "../../../../../../api/queries/useUserQuery";
import { ReportHeader } from "../../../../../BusinessInsights/components/ReportHeader/ReportHeader";
import DownloadDropdown from "../../../../components/DownloadDropdown";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";
import { Button } from "../../../../../../shared/Button/Button";
import classes from "../../../../newBusinessInsightsContent.module.scss";
import { Modal } from "../../../../../../shared/Modal/Modal";
import { svg } from "../../../../../../assets/svg";

const modalInfo = {
  title: "membershipDeclineReport.info.title",
  rows: ["membershipDeclineReport.info.note"],
};

export function Header({ period, requestParams, isReportsLoading }) {
  const { tBi } = useAppTranslation.BusinessInsights();
  const { data: user } = useCurrentUserQuery();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  return (
    <ReportHeader
      label={tBi("membershipDeclineReport.label")}
      left={
        <Button
          size="small"
          variant="text"
          className={classes.infoButton}
          onClick={() => setIsInfoModalOpen(true)}
        >
          <img src={svg.infoPrimary} alt="info" width="20px" />
        </Button>
      }
    >
      <DateRangePicker
        isDisabled={isReportsLoading}
        size="small"
        dateFormat={user?.dateFormat}
        onChange={({ startDate, endDate }) => {
          period.update({
            from: startDate,
            to: endDate,
          });
        }}
        value={{
          startDate: period.value.from,
          endDate: period.value.to,
        }}
      />
      <DownloadDropdown
        params={requestParams}
        downloadRoute={HTTP_ENDPOINTS.getMembershipDeclineReport()}
      />
      <Modal
        isOpen={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
        header={<Modal.Title>{tBi(modalInfo?.title)}</Modal.Title>}
        contentClassName={classes.infoModalContent}
      >
        {modalInfo?.rows.map((key) => (
          <p key={key}>
            <Trans
              i18nKey={tBi(key)}
              components={{
                b: <b />,
              }}
            />
          </p>
        ))}
      </Modal>
    </ReportHeader>
  );
}

Header.propTypes = {
  period: PropTypes.shape({
    value: PropTypes.shape({
      from: PropTypes.instanceOf(Date),
      to: PropTypes.instanceOf(Date),
    }),
    update: PropTypes.func,
  }).isRequired,
  isReportsLoading: PropTypes.bool.isRequired,
};
